import { defineMessages } from 'react-intl';

const messages = defineMessages({
  city: {
    id: 'features.formAddress.city',
    defaultMessage: 'City',
  },
  cityOptional: {
    id: 'features.formAddress.cityOptional',
    defaultMessage: 'City (Optional)',
  },
  country: {
    id: 'features.formAddress.country',
    defaultMessage: 'Country',
  },
  countryOptional: {
    id: 'features.formAddress.countryOptional',
    defaultMessage: 'Country (Optional)',
  },
  isAddressPublic: {
    id: 'features.formAddress.isAddressPublic',
    defaultMessage: 'Mark this Address as Public',
  },
  isAddressPublicHelperText: {
    id: 'features.formAddress.isAddressPublicHelperText',
    defaultMessage:
      'If checked, this address will be visible to others who are visiting your profile.',
  },
  street: {
    id: 'features.formAddress.street',
    defaultMessage: 'Street',
  },
  streetOptional: {
    id: 'features.formAddress.streetOptional',
    defaultMessage: 'Street (Optional)',
  },
  zip: {
    id: 'features.formAddress.zip',
    defaultMessage: 'Zip',
  },
  zipOptional: {
    id: 'features.formAddress.zipOptional',
    defaultMessage: 'Zip (Optional)',
  },
});

export default messages;
